<div>  
    <div class="container-md mt-5">

        <div class="col-12 mt-5" style="padding: 20px;margin-bottom: 20px;margin-top: 20px;">
            <h4 class="mb-0 text-dark mt-5 text-center" data-aos="fade-up">
              <strong>SERVICES</strong><br>
            </h4>
          </div>

        <div class="row d-flex justify-content-center">   
            <div class="col-md-6 col-xl-3 mb-4">
                <a href="#" [routerLink]="'/Clients'">
                  <div class="card shadow border-bottom-yellow1 py-3" data-aos="fade-up">
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 text-sm-left mb-0">
                            <span class="title">
                                Gestion des clients
                            </span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon"><i class="fas fa-clipboard-list fa-2x text-gray-400"></i></div>
                      </div>
                    </div>
                  </div>
                </a>
            </div>
            <div class="col-md-6 col-xl-3 mb-4">
                <a href="#" [routerLink]="'/Subscription'">
                  <div class="card shadow border-bottom-yellow1 py-3" data-aos="fade-up">
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 text-sm-left mb-0">
                            <span class="title">
                                Gestion de souscription
                            </span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon"><i class="fas fa-clipboard-list fa-2x text-gray-400"></i></div>
                      </div>
                    </div>
                  </div>
                </a>
            </div>
            <div class="col-md-6 col-xl-3 mb-4">
              <a href="#" [routerLink]="'/GestionGroupes'">
                <div class="card shadow border-bottom-yellow1 py-3" data-aos="fade-up">
                  <div class="card-body">
                    <div class="row align-items-center no-gutters">
                      <div class="col">
                        <div class="text-dark font-weight-bold h6 text-sm-left mb-0">
                          <span class="title">
                              Gestion de documents
                          </span>
                        </div>
                        <div class="mb-0 text-xs"></div>
                      </div>
                      <div class="col-auto icon"><i class="fas fa-clipboard-list fa-2x text-gray-400"></i></div>
                    </div>
                  </div>
                </div>
              </a>
          </div>
            <div class="col-md-6 col-xl-3 mb-4">
              <a href="#" [routerLink]="'/Configuration'">
                <div class="card shadow border-bottom-yellow1 py-3" style="min-height: 115px;" data-aos="fade-up">
                  <div class="card-body">
                    <div class="row align-items-center no-gutters">
                      <div class="col">
                        <div class="text-dark font-weight-bold h6 text-sm-left mb-0">
                          <span class="title">
                              Configuration
                          </span>
                          <div></div>
                        </div>
                        <div class="mb-0 text-xs"></div>
                      </div>
                      <div class="col-auto icon"><i class="fas fa-clipboard-list fa-2x text-gray-400"></i></div>
                    </div>
                  </div>
                </div>
              </a>
          </div>

          <div class="col-md-6 col-xl-3 mb-4">
            <a href="#" [routerLink]="'/GestionRoles'">
              <div class="card shadow border-bottom-yellow1 py-3" style="min-height: 115px;" data-aos="fade-up">
                <div class="card-body">
                  <div class="row align-items-center no-gutters">
                    <div class="col">
                      <div class="text-dark font-weight-bold h6 text-sm-left mb-0">
                        <span class="title">
                            Gestion de rôles
                        </span>
                        <div></div>
                      </div>
                      <div class="mb-0 text-xs"></div>
                    </div>
                    <div class="col-auto icon"><i class="fas fa-clipboard-list fa-2x text-gray-400"></i></div>
                  </div>
                </div>
              </div>
            </a>
        </div>
        </div>
    </div>
</div>
